import React from 'react';
import { Filters } from '@gin-betting/filters';
import { map } from 'lodash';

import { CategorizerTournamentMetaKey } from 'app-constants';
import { hasAnyMetaEventsInCategorizer } from '../../../utils';
import CategorizerRow from '../CategorizerRow';
import useCategorizerBody from './useCategorizerBody';

import './categorizerBody.scss';

interface Props {
    tournamentIds: string[];
    openedSportIds: string[];
    selectedSportIds: string[];
    onSportPreviewClick: (
        triggeredSportId: string,
        actionType: Filters.CheckGameType
    ) => void;
    onFilterChange: (sportIds: string[], tournamentIds?: string[]) => void;
}

const CategorizerBody: React.FC<Props> = ({
    tournamentIds,
    openedSportIds,
    selectedSportIds,
    onSportPreviewClick,
    onFilterChange,
}) => {
    const {
        outrightsCountBySport,
        sortedCategorizerItems,
        handleSportSelect,
        handleTournamentIdsChange,
    } = useCategorizerBody({
        selectedSportIds,
        onFilterChange,
    });

    return (
        <div styleName="container">
            {map(sortedCategorizerItems, categorizerItem => (
                <CategorizerRow
                    key={categorizerItem.name}
                    selectedTournamentIds={tournamentIds}
                    outrightsCount={
                        outrightsCountBySport[categorizerItem.value]
                    }
                    categorizerItem={categorizerItem}
                    isOpened={openedSportIds.includes(categorizerItem.value)}
                    isSelected={selectedSportIds.includes(
                        categorizerItem.value
                    )}
                    onSportSelected={handleSportSelect}
                    onSportPreviewClick={onSportPreviewClick}
                    onTournamentIdsChange={handleTournamentIdsChange}
                    isLive={hasAnyMetaEventsInCategorizer(
                        categorizerItem.meta,
                        CategorizerTournamentMetaKey.LiveEventsCount
                    )}
                />
            ))}
        </div>
    );
};

export default CategorizerBody;
